import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  SignIn,
  SignInResponse,
  SuccessResponse,
  ForgotPasswordType,
  ResetPasswordType,
  ChangePasswordType,
  QrcodeType,
  QtpResponse,
} from '../services/loginService';
import {
  Login,
  forgotPassword,
  ResetPassword,
  ChangePassword,
  Qrotp,
  getUserDetails,
} from '../services/loginService';

export const useLogin = () => {
  return useMutation<SignInResponse, Error, SignIn>({
    mutationFn: async (user) => {
      const data = await Login(user);
      return data;
    },
  });
};
export const useForgotPassword = () => {
  return useMutation<SignInResponse, Error, ForgotPasswordType>({
    mutationFn: async (user) => {
      const data = await forgotPassword(user);
      return data;
    },
  });
};
export const useQrcode = () => {
  return useMutation<QtpResponse, Error, QrcodeType>({
    mutationFn: async (user) => {
      console.log('from hook', user);
      const data = await Qrotp(user);
      return data;
    },
  });
};
export const useResetPassword = () => {
  return useMutation<SuccessResponse, Error, ResetPasswordType>({
    mutationFn: async (user) => {
      const data = await ResetPassword(user);
      return data;
    },
  });
};
export const useChangePassword = () => {
  return useMutation<SuccessResponse, Error, ChangePasswordType>({
    mutationFn: async (user) => {
      const data = await ChangePassword(user);
      return data;
    },
  });
};

export const useGetUserDetails = (email?: string) => {
  const { data, isLoading, isError, error, refetch, isPending } = useQuery({
    queryKey: ['currentuserdetails', email],
    queryFn: async () => {
      if (!email) throw new Error('Email is required'); // safety guard
      return await getUserDetails(email);
    },
    enabled: !!email,
    staleTime: 0,
    gcTime: 0,
  });

  return {
    userDetails: data,
    isLoading,
    isError,
    isPending,
    error,
    refetch,
  };
};
